var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{attrs:{"gutter":[30, 20]}},[_c('a-col',{attrs:{"span":15}},[_c('div',{ref:"BarChart",staticClass:"chart-item"})]),_c('a-col',{attrs:{"span":9}},[_c('div',{ref:"PieChart",staticClass:"chart-item"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }